const firebaseConfig = {
  apiKey: "AIzaSyAJPGCd6ypfVcQndA-ERtHHixNfM6-Ff7U",
  authDomain: "palmeiras-64b7e.firebaseapp.com",
  projectId: "palmeiras-64b7e",
  storageBucket: "palmeiras-64b7e.appspot.com",
  messagingSenderId: "777890177630",
  appId: "1:777890177630:web:2ee5bc30a9e4c4a3c44acf",
  measurementId: "G-DHHHP9MR4J",
};
export default firebaseConfig;
